import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { notification, Space } from 'antd';

import { EXECUTED, selectors, TRANSACTION_TYPES } from 'state';
import { formatters } from 'services';
import {
  simplifiedOptionSnapshotActionLabel,
  simplifiedOptionSnapshotContracts,
  simplifiedOptionCurrencySymbol,
} from '../../state/app/simplified_options/presentation';

const OrderFilled: React.FC = () => {
  const lastOrder = useSelector(selectors.lastOrder);
  const currencies = useSelector(selectors.currencies);
  const financialInstruments = useSelector(selectors.financialInstruments);
  const underlyingAssets = useSelector(selectors.underlyingAssets);

  useEffect(() => {
    if (!lastOrder) return;
    if (lastOrder.status !== EXECUTED) return;

    const { resourcetype, financial_instrument, open_price, transaction } =
      lastOrder;

    const assetId = financialInstruments[financial_instrument].underlying_asset;
    const asset = underlyingAssets[assetId];
    const snapshot = lastOrder.simplified_option_snapshot;

    if (resourcetype === 'MarketOrder' && !snapshot) return;

    if (snapshot) {
      const nativeCurrency = simplifiedOptionCurrencySymbol(
        snapshot.native_currency,
        currencies,
      );
      notification.info({
        message: 'Options order filled',
        description: (
          <Space direction="vertical">
            <span>Ticker: {asset.ticker}</span>
            <span>
              Action:{' '}
              {simplifiedOptionSnapshotActionLabel(
                transaction,
                snapshot.execution_effect,
              )}
            </span>
            <span>
              Contracts:{' '}
              {formatters.commasNoDigits(
                simplifiedOptionSnapshotContracts(snapshot),
              )}
            </span>
            <span>
              Premium: {formatters.commas2Digits(snapshot.signed_total_premium)}{' '}
              {nativeCurrency}
            </span>
          </Space>
        ),
      });
      return;
    }

    const price = formatters.priceFormat(
      open_price,
      asset.ticker,
      currencies[asset.base_currency].symbol,
      asset.resourcetype,
    );

    notification.info({
      message: 'Order filled',
      description: (
        <Space direction="vertical">
          <span>Ticker: {asset.ticker}</span>
          <span>Direction: {TRANSACTION_TYPES[transaction]}</span>
          <span>
            {asset.resourcetype === 'Futures' ? 'Contracts' : 'Quantity'}:{' '}
            {asset.resourcetype === 'Futures'
              ? formatters.commasNoDigits(
                  formatters.unitsToContracts(
                    lastOrder.quantity,
                    asset.lot_size,
                  ),
                )
              : lastOrder.quantity}
          </span>
          <span>Price: {price}</span>
        </Space>
      ),
    });
  }, [lastOrder?.id]);

  return null;
};

export default OrderFilled;
